<template>
  <div>
    <p class='title'>Раздел в разработке</p>
  </div>
</template>

<script>

</script>